var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var MailRead = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 960 959.96", width: "1em", height: "1em" }, props),
    React.createElement("defs", null),
    React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
        React.createElement("g", { id: "icon" },
            React.createElement("path", { className: "cls-1", d: "M915.91 262.06l-384-246.85a96.19 96.19 0 0 0-103.82 0l-384 246.85A95.61 95.61 0 0 0 0 342.82V864a96.11 96.11 0 0 0 96 96h768a96.11 96.11 0 0 0 96-96V342.82a95.61 95.61 0 0 0-44.09-80.76zM896 864a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V342.82a31.85 31.85 0 0 1 14.7-26.92L462.7 69a32.05 32.05 0 0 1 34.6 0l384 246.86a31.85 31.85 0 0 1 14.7 26.96z" }),
            React.createElement("path", { className: "cls-1", d: "M782.7 483.41L497.3 666.88a32.09 32.09 0 0 1-34.6 0L177.3 483.41a32 32 0 1 0-34.6 53.84l285.39 183.46a96.19 96.19 0 0 0 103.82 0L817.3 537.25a32 32 0 1 0-34.6-53.84z" }))))); };
export default MailRead;
//# sourceMappingURL=MailRead.js.map